import moment from 'moment';
import { views } from '../constants/views';
import { isAfterStartPeriod, isBeforeEndPeriod } from './helpers';

const sortFn = (tasks) => {
  return tasks.sort((a, b) => {
    if (moment(a.fromDate).isSame(b.fromDate)) {
      return moment(a.toDate) - moment(b.toDate);
    } else {
      return moment(a.fromDate) - moment(b.fromDate);
    }
  });
};

const minutesDiff = (fromDate, toDate) =>
  moment(toDate).diff(moment(fromDate), 'minutes');

// "Весь день" в нашей сетке — это именно daylongTasks.
// Сейчас туда попадали смены ровно на 8 часов (08:00–16:00), из‑за условия ">= 8".
// Делаем порог строгим: daylong считаем только то, что ДОЛЬШЕ 8 часов.
const isDaylongByDuration = (fromDate, toDate) =>
  minutesDiff(fromDate, toDate) > 8 * 60;

const generateMonthData = (data, startPeriod, totalTime, taskId) => {
  const workers = [];
  const calendarGridData = [];
  const dataSet = new Set(data);

  for (let i = 0; i < totalTime; i++) {
    const day = startPeriod.clone().add(i, 'day');
    const tasks = [];

    if (dataSet.size) {
      dataSet.forEach((task) => {
        const startsOnDay = moment(task.fromDate).isSame(day, 'day');

        if (startsOnDay) {
          let workerIndex = workers.findIndex(
            (worker) => worker.id === task.worker.id
          );

          if (workerIndex < 0) {
            workers.push({
              ...task.worker,
              checked: true,
              index: workers.length,
              requestCount: 1,
            });
            workerIndex = workers.length - 1;
          } else {
            workers[workerIndex].requestCount += 1;
          }

          if (task.id !== taskId) {
            const newTask = { ...task, index: workerIndex, visible: true };

            tasks.push(newTask);
          }
        }
      });
    }

    calendarGridData.push({
      day,
      tasks: sortFn(tasks),
    });
  }

  return { workers, calendarGridData };
};

const generateWeekData = (data, startPeriod, totalTime, taskId) => {
  const workers = [];
  const calendarGridData = [];
  const dataSet = new Set(data);

  for (let i = 0; i < totalTime; i++) {
    const day = startPeriod.clone().add(i, 'day');
    const tasks = [];
    const daylongTasks = [];

    if (dataSet.size) {
      dataSet.forEach((task) => {
        const isSameOrAfter = isAfterStartPeriod(task.fromDate, day);
        const isSameOrBefore = isBeforeEndPeriod(task.toDate, day);

        if (isSameOrAfter && isSameOrBefore) {
          let workerIndex = workers.findIndex(
            (worker) => worker.id === task.worker.id
          );

          if (workerIndex < 0) {
            workers.push({
              ...task.worker,
              checked: true,
              index: workers.length,
              requestCount: 1,
            });
            workerIndex = workers.length - 1;
          } else {
            workers[workerIndex].requestCount += 1;
          }

          if (task.id !== taskId) {
            const newTask = { ...task, index: workerIndex, visible: true };

            if (isDaylongByDuration(task.fromDate, task.toDate)) {
              daylongTasks.push(newTask);
            } else {
              tasks.push(newTask);
            }
          }
        }
      });
    }

    calendarGridData.push({
      day,
      tasks: sortFn(tasks),
      daylongTasks: sortFn(daylongTasks),
    });
  }

  return { workers, calendarGridData };
};

const generateDayData = (data, startPeriod, taskId) => {
  const workers = [];
  const calendarGridData = [
    { day: startPeriod.clone(), tasks: [], daylongTasks: [] },
  ];

  data.forEach((task) => {
    let workerIndex = workers.findIndex(
      (worker) => worker.id === task.worker.id
    );

    if (workerIndex < 0) {
      workers.push({
        ...task.worker,
        checked: true,
        index: workers.length,
        requestCount: 1,
      });
      workerIndex = workers.length - 1;
    } else {
      workers[workerIndex].requestCount += 1;
    }

    if (task.id !== taskId) {
      const newTask = { ...task, index: workerIndex, visible: true };

      if (isDaylongByDuration(task.fromDate, task.toDate)) {
        calendarGridData[0].daylongTasks.push(newTask);
      } else {
        calendarGridData[0].tasks.push(newTask);
      }
    }
  });

  calendarGridData[0].tasks = sortFn(calendarGridData[0].tasks);
  calendarGridData[0].daylongTasks = sortFn(calendarGridData[0].daylongTasks);

  return { workers, calendarGridData };
};

export const getWorkersAndCalendarData = ({
  data,
  startPeriod,
  totalTime,
  view,
  taskId,
}) => {
  if (view === views.month) {
    return generateMonthData(data, startPeriod, totalTime, taskId);
  }

  if (view == views.week) {
    return generateWeekData(data, startPeriod, totalTime, taskId);
  }

  return generateDayData(data, startPeriod, taskId);
};
